import { render, staticRenderFns } from "./Forms.component.vue?vue&type=template&id=8c414fdc"
import script from "./Forms.component.vue?vue&type=script&lang=js"
export * from "./Forms.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports